import _createForOfIteratorHelper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import a from "../util/net.js";
import r from "../managers/braze-instance.js";
import ControlMessage from "./models/control-message.js";
import HtmlMessage from "./models/html-message.js";
import InAppMessage from "./models/in-app-message.js";
import InAppMessageButton from "./models/in-app-message-button.js";
import c from "../common/event-logger.js";
import { newInAppMessageFromJson as ut } from "./in-app-message-factory.js";
import { randomInclusive as l } from "../util/math.js";
import H from "../models/request-result.js";
import { logger as E, EventTypes as m } from "../../shared-lib/index.js";
import u from "../managers/subscription-manager.js";
import pt from "../triggers/models/trigger.js";
import { BRAZE_ACTION_URI_REGEX as to } from "../util/validation-utils.js";
import { containsPushPrimerBrazeAction as ft, containsUnknownBrazeAction as dt, getDecodedBrazeAction as eo, ineligibleBrazeActionURLErrorMessage as jt, INELIGIBLE_BRAZE_ACTION_URL_ERROR_TYPES as vt } from "../util/braze-actions.js";
import yt from "../Push/utils/push-utils.js";
import h from "../util/request-header-utils.js";
import { STORAGE_KEYS as s } from "../managers/storage-manager.js";
import { FullScreenMessage, ModalMessage, SlideUpMessage } from "./index.js";
var ea = /*#__PURE__*/function () {
  function ea(t, e, s, i) {
    _classCallCheck(this, ea);
    this.B = t, this.C = e, this.j = s, this.Cs = i, this.B = t, this.C = e, this.j = s, this.Cs = i, this.yi = new u(), r.q(this.yi), this.Mi = 1e3, this.ki = 6e4, this.zi = null, this.Bi = null, this.Ri = null;
  }
  _createClass(ea, [{
    key: "_i",
    value: function _i() {
      return this.yi;
    }
  }, {
    key: "qi",
    value: function qi(t) {
      return this.yi.wt(t);
    }
  }, {
    key: "xi",
    value: function xi() {
      return this.zi;
    }
  }, {
    key: "Pi",
    value: function Pi(t) {
      this.zi = t;
    }
  }, {
    key: "rt",
    value: function rt(t, e, s, i) {
      var r = new H();
      var n;
      if (e === m.Gi || t instanceof ControlMessage) {
        if (!t.Qt()) return E.info("This in-app message has already received an impression. Ignoring analytics event."), r;
      } else if (e === m.$i || t instanceof HtmlMessage && e === m.Fi) {
        if (!t.$t(i)) return E.info("This in-app message has already received a click. Ignoring analytics event."), r;
      }
      return n = t instanceof ControlMessage ? {
        trigger_ids: [t.triggerId]
      } : this.Oi(t), null == n ? r : (t.messageExtras && (n.message_extras = t.messageExtras), null != s && (n.bid = s), c.rt(e, n));
    }
  }, {
    key: "Xi",
    value: function Xi(t, e) {
      var s = new H();
      if (!t.$t()) return E.info("This in-app message button has already received a click. Ignoring analytics event."), s;
      var i = this.Oi(e);
      return null == i ? s : t.id === InAppMessageButton.Hi ? (E.info("This in-app message button does not have a tracking id. Not logging event to Braze servers."), s) : (null != t.id && (i.bid = t.id), c.rt(m.Fi, i));
    }
  }, {
    key: "Ji",
    value: function Ji(t) {
      var e = t.messageFields;
      return null != e && e.is_push_primer || !1;
    }
  }, {
    key: "Ki",
    value: function Ki(t) {
      if (!(t instanceof InAppMessage)) return;
      var e = function e(t) {
        if (!t) return;
        var e = eo(t);
        if (dt(e)) return jt(vt.Li, "In-App Message");
        if (ft(e)) {
          var _t = yt.Qi();
          if (!_t.Ui) return yt.Vi(_t.reason, "In-App Message");
        }
      };
      if (this.Ji(t)) {
        var _t2 = yt.Qi();
        if (!_t2.Ui) return yt.Vi(_t2.reason, "In-App Message");
      }
      var s = t.buttons || [];
      var i;
      var _iterator = _createForOfIteratorHelper(s),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t3 = _step.value;
          if (_t3.clickAction === InAppMessage.ClickAction.URI && _t3.uri && to.test(_t3.uri) && (i = e(_t3.uri), i)) return i;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return t.clickAction === InAppMessage.ClickAction.URI && t.uri && to.test(t.uri) ? e(t.uri) : void 0;
    }
  }, {
    key: "Wi",
    value: function Wi(t, e) {
      e !== this.Ri && this.Yi(), this.Bi = t, this.Ri = e;
    }
  }, {
    key: "Yi",
    value: function Yi() {
      null != this.Bi && (clearTimeout(this.Bi), this.Bi = null, this.Ri = null);
    }
  }, {
    key: "Zi",
    value: function Zi(t, e, s, i) {
      var _this = this;
      var r = this.B;
      if (!r) return;
      this.Ri && t.triggerId !== this.Ri && (this.Yi(), h.Ci(this.j, h.H.Ir));
      var n = r.Mr(!1),
        o = r.$(n);
      o.template = {
        trigger_id: t.triggerId,
        trigger_event_type: e
      }, null != s && (o.template.data = s.Ar());
      var u = r.A(o, h.H.Ir);
      r.J(o, function () {
        var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
        var n = _this.B;
        if (!n) return;
        var m = new Date().valueOf();
        h.K(_this.j, h.H.Ir, m), -1 !== r && u.push(["X-Braze-Req-Tokens-Remaining", r.toString()]);
        var c,
          p,
          f = !1;
        a.O({
          url: "".concat(n.V(), "/template/"),
          data: o,
          headers: u,
          W: function W(e) {
            if (!n.Y(o, e, u)) return void ("function" == typeof t.Tr && t.Tr());
            if (n.Z(), null == e || null == e.templated_message) return;
            var s = e.templated_message;
            if (s.type !== pt._r.Br) return;
            var i = ut(s.data);
            if (null == i) return;
            var r = _this.Ki(i);
            if (r) return E.error(r), void ("function" == typeof t.Tr && t.Tr());
            "function" == typeof t.qr && t.qr(i);
          },
          error: function error(e) {
            f = !0, c = e, p = "getting user personalization for message ".concat(t.triggerId, ".");
          },
          tt: function tt(r, o) {
            if (new Date().valueOf() - t.Er < t.Gr) {
              var _r = 0;
              if (f) {
                var _e = Math.min(t.Gr, _this.ki),
                  _s = _this.Mi;
                null == i && (i = _s), _r = Math.min(_e, l(_s, 3 * i));
              }
              n.st(o, function () {
                _this.Zi(t, e, s, _r);
              }, h.H.Ir, function (e) {
                return _this.Wi(e, t.triggerId);
              }, function () {
                return _this.Yi();
              }, _r);
            }
            f && n._(c, p);
          }
        });
      }, h.H.Ir);
    }
  }, {
    key: "Oi",
    value: function Oi(t) {
      if (null == t.triggerId) return E.info("The in-app message has no analytics id. Not logging event to Braze servers."), null;
      var e = {};
      return null != t.triggerId && (e.trigger_ids = [t.triggerId]), e;
    }
  }, {
    key: "Ee",
    value: function Ee(t) {
      return !!this.j && !(!(t && t instanceof InAppMessage && t.constructor !== InAppMessage) || t instanceof ControlMessage) && this.j.ft(s.ct.Nr, t.dt());
    }
  }, {
    key: "zr",
    value: function zr() {
      if (!this.j) return null;
      var t = this.j.lt(s.ct.Nr);
      if (!t) return null;
      var e;
      switch (t.type) {
        case InAppMessage.Ke.Or:
          e = FullScreenMessage.Xr(t);
          break;
        case InAppMessage.Ke.Hr:
        case InAppMessage.Ke.Je:
        case InAppMessage.Ke.Ao:
          e = HtmlMessage.Xr(t);
          break;
        case InAppMessage.Ke.Jr:
        case InAppMessage.Ke.Io:
          e = ModalMessage.Xr(t);
          break;
        case InAppMessage.Ke.Kr:
          e = SlideUpMessage.Xr(t);
      }
      return e && this.Lr(), e;
    }
  }, {
    key: "Lr",
    value: function Lr() {
      this.j && this.j.Nt(s.ct.Nr);
    }
  }]);
  return ea;
}();
export { ea as default };